import React from "react";

const Process = () => {
  const steps = [
    {
      number: "01",
      title: "Clarify the scope",
      description: "We clarify the product goal, users, constraints, and expected outcome before implementation begins.",
    },
    {
      number: "02",
      title: "Propose the solution",
      description: "The architecture, execution path, priorities, and delivery milestones are made clear and practical.",
    },
    {
      number: "03",
      title: "Build and report progress",
      description: "Work moves in visible stages, with decisions, risks, and progress communicated throughout delivery.",
    },
    {
      number: "04",
      title: "Deliver and support",
      description: "The final release, documentation, and handover guidance are delivered with a clear path for what comes next.",
    },
  ];

  return (
    <section id="process" className="section bg-light">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">How I work</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-3 wow fadeInUp">
          Collaboration starts with clarity
        </h2>
        <p className="text-muted text-center text-5 mb-5 wow fadeInUp">
          Every project follows a visible path so decisions, timing, and deliverables stay clear for everyone.
        </p>

        <div className="row gy-4">
          {steps.map((step) => (
            <div className="col-sm-6 col-lg-3 wow fadeInUp" key={step.number}>
              <div className="border rounded p-4 h-100 bg-white">
                <span className="text-primary text-6 fw-600">{step.number}</span>
                <h3 className="text-5 fw-600 mt-3 mb-3">{step.title}</h3>
                <p className="text-muted mb-0">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
